import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoginRouter from "../components/LoginRouter/LoginRouter.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "LoginRouter",
    component: LoginRouter
  }
];

const router = new VueRouter({
  routes
});

export default router;
